import { captureInboundLeadHandoffTokenFromUrl } from '@/utils/inboundLeadHandoff'
import { installObjectHasOwnPolyfill } from '@/utils/objectHasOwnPolyfill'
import { captureSchoolRegistrationTokenFromUrl } from '@/utils/schoolRegistration'
import { captureFeedbackCapabilities, isFeedbackPath } from '@/utils/privateFeedback'

installObjectHasOwnPolyfill()

const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true'

void (async () => {
  if (isFeedbackPath(window.location.pathname)) {
    const capabilities = captureFeedbackCapabilities()
    const { mountFeedback } = await import('@/pages/Feedback/mountFeedback')
    mountFeedback(capabilities)
    return
  }
  captureSchoolRegistrationTokenFromUrl()
  if ('serviceWorker' in navigator) {
    // Install cache updates without reloading an active conversation or form.
    const registerWorker = () => {
      void navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error: unknown) => {
        console.error('[PWA] Failed to register service worker:', error)
      })
    }
    if (document.readyState === 'complete') {
      registerWorker()
    } else {
      window.addEventListener('load', registerWorker, { once: true })
    }
  }
  if (isMaintenanceMode) {
    await import('@/maintenance/mountMaintenance')
    const { initializeLiveUpdates } = await import('@/services/liveUpdate/service')
    void initializeLiveUpdates()
    return
  }

  captureInboundLeadHandoffTokenFromUrl()
  await import('@/bootstrapApp')
})()
